/**
 * Veeroute.Lastmile
 * Veeroute Lastmile API
 *
 * The version of the OpenAPI document: 3.15.183137
 * Contact: support@veeroute.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WorkAndRestRulesLastmile } from './workAndRestRules';
import { UniversalTariffLastmile } from './universalTariff';
import { TimeWindowLastmile } from './timeWindow';


/**
 * Performer\'s or vehicle shift that determines the availability of the resource for planning within its time window.   * `availability_time` - a time shift window when the performer or vehicle can perform work at locations and drive between locations.   * `working_time` - the working time window, when the performer or vehicle can perform work at locations, must be inside the time window. 
 */
export interface ShiftLastmile { 
    /**
     * Shift key, unique ID.
     */
    key: string;
    /**
     * Shift type that can be a performer (`PERFORMER`) or a transport (`TRANSPORT`).
     */
    shift_type: ShiftLastmileShiftTypeEnum;
    /**
     * Resource key referenced by the shift.
     */
    resource_key: string;
    availability_time: TimeWindowLastmile;
    working_time: TimeWindowLastmile;
    /**
     * Start location key.  If not specified, the trip starts from the first order location. 
     */
    start_location_key?: string;
    /**
     * Finish location key.  If not specified, the trip finishes on the last order location. 
     */
    finish_location_key?: string;
    /**
     * Limit of the number of unique locations in one trip. If not specified, number of locations is not limited. 
     */
    max_locations?: number;
    /**
     * Limit of the number of stops in one trip. If not specified, number of stops is not limited. 
     */
    max_stops?: number;
    tariff?: UniversalTariffLastmile;
    work_and_rest_rules?: WorkAndRestRulesLastmile;
    /**
     * Attributes, used to add service information that does not affect planning.
     */
    attributes?: Set<string>;
}
export enum ShiftLastmileShiftTypeEnum {
    PERFORMER = 'PERFORMER',
    TRANSPORT = 'TRANSPORT'
};



